import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getIsPreviewStatus } from '../../../state/app';

function mapStateToProps(state) {
    return {
        isPreview: getIsPreviewStatus(state)
    };
}

const ContentfulVideo = ({ video, isPreview, altOverride }) => {
    if (typeof video != 'undefined' && video != null) {
        if (isPreview == true) {
            video = video.fields;
        }

        return (
            <>
                <video autoPlay muted loop playsInline>
                    <source src={video.file.url} type="video/mp4" className="video-auto-play" />
                </video>
            </>
        )
    } else {
        return <></>
    }

}
ContentfulVideo.propTypes = {
    isPreview: PropTypes.bool,
}
const Video = connect(mapStateToProps)(ContentfulVideo);

export { Video }
